import { ContextSelectionType } from './ContextSelectionContext';

export const iconColorClassMap = {
  [ContextSelectionType.Product]: 'text-success',
  [ContextSelectionType.Tool]: 'text-warning',
  [ContextSelectionType.Experiment]: 'text-blue-500',
};
